import React from 'react'
import Edit from '../../crud/edit'

const fields = [
  {
    name: 'List ID',
    prop: 'value',
    type: 'text'
  }
]

const EditSettings = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit MailChimp List ID'
      fields={fields}
      apiPath='admin/settings/mailchimp_list_id'
      successRedirectPath='/settings'
      buildMenuItems={() => {}}
      disableDelete
    />
  )
}

export default EditSettings
